"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This gets replaced on build time.
// We do not require() the package.json, since
// (depending on their bundler used) it would result it
// being embedded in the dist of the consumer project
// which we want to avoid, both b/c of the dist size increase &
// the security concerns of including the versions of the dependencies
const sdkVersion = '16.45.1';
exports.default = sdkVersion;
